// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3f31w","containerItemsCenter":"Skeleton_containerItemsCenter__3oVQD"};